// 构建期由 webpack DefinePlugin 注入 AXIS_MODE_ASSET_PREFIX（相对 shared-assets/src）
// 默认品牌：keyboard/axisMode；其它品牌若有 axisMode/{brandId}/ 则用之
import { sharedAssetUrl } from "../../assetUrl";

declare const process: {
  env: {
    AXIS_MODE_ASSET_PREFIX?: string;
  };
};

const AXIS_PREFIX =
  (typeof process !== "undefined" && process.env.AXIS_MODE_ASSET_PREFIX) ||
  "keyboard/axisMode";

export const keyAxisImage01 = sharedAssetUrl(
  `${AXIS_PREFIX}/keyAxisImage-01.png`
);
export const keyAxisImage02 = sharedAssetUrl(
  `${AXIS_PREFIX}/keyAxisImage-02.png`
);
export const keyAxisImage03 = sharedAssetUrl(
  `${AXIS_PREFIX}/keyAxisImage-03.png`
);
